module.exports = __webpack_public_path__ + "static/media/icon-equipe-yellow.08c6523c.svg";